import styled from "styled-components";

export const Container = styled.div`
  max-width: 960px;
  color: #ffffff;
`;

export const Text = styled.p`
  margin: 0 0 1rem;
  color: ${(props) => props.theme.color.lightBg};
  font-size: clamp(1.1rem, 2vw, 1.5rem);
`;

export const BigText = styled.h1`
  margin: 0;
  font-size: clamp(3.25rem, 11vw, 8rem);
  line-height: 0.98;
  letter-spacing: -0.055em;
`;

export const Role = styled.p`
  max-width: 780px;
  margin: 1.75rem 0 0;
  font-size: clamp(1.25rem, 3vw, 2.15rem);
  line-height: 1.35;
`;

export const Location = styled.p`
  margin: 1.1rem 0 0;
  color: ${(props) => props.theme.color.lightBg};
  font-size: 1.05rem;
`;
